import * as React from 'react';

import { pure } from 'recompose';

const GDPRArchSVG = (props: any) => (
  <svg viewBox="0 0 167 66" style={{ width: '100%' }} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Shapes</title>
    <defs />
    <g
      id="Artboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-35.000000, -33.000000)"
      opacity="0.1"
    >
      <g id="Banner" transform="translate(35.000000, 33.000000)" stroke="#000000" strokeWidth="6">
        <g id="sessionnotificationbg">
          <g id="shapes">
            <g transform="translate(-29.000000, -21.000000)">
              <g id="Clock" transform="translate(155.049449, 36.684704)">
                <path
                  d="M37.9396098,17.4698049 C37.9396098,28.774791 28.7750662,37.9396098 17.4698049,37.9396098 C6.16454361,37.9396098 -3,28.774791 -3,17.4698049 C-3,6.16481885 6.16454361,-3 17.4698049,-3 C28.7750662,-3 37.9396098,6.16481885 37.9396098,17.4698049 Z"
                  id="Stroke-1"
                />
                <polyline id="Stroke-3" points="18.1685971 4.19275318 18.1685971 17.4698049 9.08429855 17.4698049" />
              </g>
              <rect
                id="Rectangle-path"
                transform="translate(31.500000, 30.204937) rotate(201.000000) translate(-31.500000, -30.204937) "
                x="7"
                y="8"
                width="49"
                height="44.4098749"
              />
              <rect
                id="Rectangle-path"
                transform="translate(82.000000, 79.000000) rotate(157.000000) translate(-82.000000, -79.000000) "
                x="71"
                y="68"
                width="22"
                height="22"
              />
              <circle id="Oval" cx="103.5" cy="28.5" r="7.5" />
              <path d="M118.5,59.5 L129.5,44.5" id="Line" strokeLinecap="square" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const GDPRArchSVGPure = pure(GDPRArchSVG);
GDPRArchSVGPure.displayName = 'GDPRArchSVG';

export default GDPRArchSVGPure;
